<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid page-selector-container">
    <div class="row">
      <div class="col-12">
        <table border="0" cellspacing="3" style="border-collapse:initial;">
          <tr v-for="(page, index) in pages">
            <td class="px-1" style="background-color:orange;">
              <span class="badge badge-primary badge-pill" style="top:6px; background-color:white;color:black;">{{index + 1}}</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "procedure-page-selector",
    components: {
      
    },
    props: {
    },
    data() {
      return {

      };
    },
    methods: {
      getPagesFromElement(element) {
        var list = [];
        if (element.ElementType == 13) {
          list.push(element);
        }
        for (var i = 0; i < element.Elements.length; i++) {
          var childList = this.getPagesFromElement(element.Elements[i]);
          for (var k = 0; k < childList.length; k++) {
            list.push(childList[k]);
          }
        }
        return list;
      },
      getPages() {
        var proc = this.procedure;
        var list = [];
        if (proc.Elements.length > 0) {
          for (var i = 0; i < proc.Elements.length; i++) {
            var childList = this.getPagesFromElement(proc.Elements[i]);
            for (var k = 0; k < childList.length; k++) {
              list.push(childList[k]);
            }
          }
        }
        return list;
      },
      getId() {
        return this._uid;
      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      init() {

      },
    },
    computed: {
      procedure: {
        get() {
          return this.$store.state.procedure;
        },
        set(value) {
          this.$store.commit('saveprocedure', value)
        }
      },
      pages: {
        get() {
          return this.getPages();
        },
      }
    },
    watch: {
      
    },
    mounted() {
      this.init();
    },
    created() {

    },
  };

</script>

<style scoped>
  .page-selector-container{
    
  }
</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-page-selector.vue